import type {
  AuthV2ConfirmForgotPasswordRequest,
  AuthV2ForgotPasswordRequest,
  AuthV2LoginRequest,
  Configuration,
} from '@repo/api-gw-sdk';
import {
  AuthV2ConfirmForgotPasswordApi,
  AuthV2ForgotPasswordApi,
  AuthV2LoginApi,
} from '@repo/api-gw-sdk';

export const authV2 = (config: Configuration) => {
  const loginApi = new AuthV2LoginApi(config);
  const forgotPasswordApi = new AuthV2ForgotPasswordApi(config);
  const confirmForgotPasswordApi = new AuthV2ConfirmForgotPasswordApi(config);

  return {
    login: (body: AuthV2LoginRequest) => loginApi.authV2Login(body),
    forgotPassword: (body: AuthV2ForgotPasswordRequest) =>
      forgotPasswordApi.authV2ForgotPassword(body),
    confirmForgotPassword: (body: AuthV2ConfirmForgotPasswordRequest) =>
      confirmForgotPasswordApi.authV2ConfirmForgotPassword(body),
  };
};
